import React, { useState, useEffect } from 'react';
import '../style/usp.css';
import {
  FaStar,
  FaUsers,
  FaGlobe,
  FaRocket,
  FaShieldAlt,
  FaVideo,
  FaAward,
} from 'react-icons/fa';

const USPSection = () => {
  const [activePoint, setActivePoint] = useState(0);
  const [lineProgress, setLineProgress] = useState(0);

  const uspPoints = [
    {
      number: '01',
      title: 'Visual Excellence',
      description: 'Cutting-edge VFX and CGI production',
      hoverDescription:
        'State-of-the-art visual effects and computer-generated imagery using latest technology',
      icon: <FaStar />,
    },
    {
      number: '02',
      title: 'Expert Team',
      description: 'Professional in-house specialists',
      hoverDescription:
        'Dedicated team of industry professionals with years of experience in visual production',
      icon: <FaUsers />,
    },
    {
      number: '03',
      title: 'Global Support',
      description: 'International production assistance',
      hoverDescription:
        '24/7 support for clients worldwide with multi-language capabilities',
      icon: <FaGlobe />,
    },
    {
      number: '04',
      title: 'Fast Delivery',
      description: 'Quick turnaround guaranteed',
      hoverDescription:
        'Efficient workflow ensures timely delivery without compromising quality',
      icon: <FaRocket />,
    },
    {
      number: '05',
      title: 'Trusted Results',
      description: 'Global brands choose us',
      hoverDescription:
        'Trusted by leading brands for consistent, high-quality visual production',
      icon: <FaShieldAlt />,
    },
  ];

  const featureCards = [
    {
      id: 1,
      title: 'Cutting-Edge Visual Production',
      subtitle: 'Cinema-Quality Standards',
      icon: <FaVideo />,
      hoverText:
        'Hollywood-grade visual effects and animation services using industry-leading software and techniques.',
    },
    {
      id: 2,
      title: 'International Production Support',
      subtitle: 'Worldwide Coverage',
      icon: <FaGlobe />,
      hoverText:
        'Global client support with local presence in multiple countries, ensuring seamless collaboration.',
    },
    {
      id: 3,
      title: 'Professional In-House Team',
      subtitle: 'Expert Specialists',
      icon: <FaUsers />,
      hoverText:
        'Skilled professionals with expertise in various visual production domains and years of experience.',
    },
    {
      id: 4,
      title: 'Fast & Trusted Results',
      subtitle: 'Quality Guaranteed',
      icon: <FaAward />,
      hoverText:
        'Proven track record of delivering exceptional results on time with complete client satisfaction.',
    },
  ];

  // Fixed progress calculation - exact positions for 5 points
  const getProgressForPoint = (pointIndex) => {
    // For 5 points: 0%, 25%, 50%, 75%, 100%
    return pointIndex * 25;
  };

  // Auto rotate active USP point every 3s with PROPER line animation
  useEffect(() => {
    const interval = setInterval(() => {
      const nextPoint = (activePoint + 1) % uspPoints.length;
      
      // Set the line progress to exactly match the next point
      setLineProgress(getProgressForPoint(nextPoint));
      
      // Update active point simultaneously
      setActivePoint(nextPoint);
      
    }, 3000);
    
    return () => clearInterval(interval);
  }, [activePoint, uspPoints.length]);

  // Handle manual point selection
  const handlePointHover = (index) => {
    setActivePoint(index);
    setLineProgress(getProgressForPoint(index));
  };

  return (
    <section className="usp-section">
      <div className="usp-container">
        {/* Upper Part */}
        <div className="usp-upper">
          <h2 className="section-title">STEP-BY-STEP EXCELLENCE</h2>

          <div className="usp-points-container">
            <div className="usp-points-row">
              {uspPoints.map((point, index) => (
                <div
                  key={index}
                  className={`usp-point ${
                    activePoint === index ? 'active' : ''
                  }`}
                  onMouseEnter={() => handlePointHover(index)}
                >
                  <div className="point-content">
                    <div className="point-number">{point.number}</div>
                    <div className="point-icon">{point.icon}</div>
                    <div className="point-text">
                      <h4 className="point-title">{point.title}</h4>
                      <p className="point-description">
                        {point.description}
                      </p>
                    </div>
                    <div className="point-hover-info">
                      <p>{point.hoverDescription}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Fixed Animated Line */}
            <div className="animated-line-container">
              <div className="line-background"></div>
              <div
                className="line-fill"
                style={{ width: `${lineProgress}%` }}
              ></div>
              <div className="line-dots">
                {uspPoints.map((_, index) => (
                  <div
                    key={index}
                    className={`line-dot ${
                      activePoint === index ? 'active' : ''
                    }`}
                  ></div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Lower Part */}
        <div className="usp-lower">
          <div className="feature-cards">
            {featureCards.map((card) => (
              <div
                key={card.id}
                className="feature-card"
              >
                <div className="card-content">
                  <div className="card-icon">{card.icon}</div>
                  <h3 className="card-title">{card.title}</h3>
                  <p className="card-subtitle">{card.subtitle}</p>
                  <div className="card-hover-text">
                    <p>{card.hoverText}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default USPSection;